import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import StockChart from '../components/StockChart';
import './PageIndustriaAnio.css';

const DATA = [
  { year: 2010, value: 166888457 },
  { year: 2011, value: 179768216 },
  { year: 2012, value: 236429065 },
  { year: 2013, value: 261541480 },
  { year: 2014, value: 298746210 },
  { year: 2015, value: 315587044 },
  { year: 2016, value: 331771842 },
  { year: 2017, value: 306571678 },
  { year: 2018, value: 247221392 },
  { year: 2019, value: 235579713 },
  { year: 2020, value: 218462123 },
  { year: 2021, value: 269624958 },
  { year: 2022, value: 263617874 },
  { year: 2023, value: 267262539 },
  { year: 2024, value: 337716286 },
  { year: 2025, value: 353510190 },
];

const EVENTS = [
  { year: 2010, label: 'Porfirio Lobo' },
  { year: 2014, label: 'JOH (1er T\u00e9rmino)' },
  { year: 2017, label: 'JOH Anuncia Reelecci\u00f3n' },
  { year: 2020, label: 'COVID-19' },
  { year: 2022, label: 'Xiomara Castro' },
];

function PageMedioTV() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="industria-page">
        <header className="industria-header">
          <button className="btn-back" onClick={() => navigate('/mixmedio-inversion-2')}>
            &#8592; Mix de Medios
          </button>
          <div className="industria-title-block">
            <h1 className="industria-title">Televisi&oacute;n</h1>
            <p className="industria-subtitle">Inversi&oacute;n publicitaria &middot; Televisi&oacute;n &middot; Honduras 2010–2025 &middot; USD</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/medio-radio')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <StockChart data={DATA} color="#60a5fa" events={EVENTS} />

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageMedioTV;
